<template>
  <v-dialog
    v-model="dialog"
    max-width="450"
    persistent
  >
    <v-card v-if="items">
      <v-card-title>Select {{ article(mode) }} {{ mode }}&hellip;</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selected" 
          :items="items" 
          :item-text="mode == 'export' ? 'uuid' : 'name'"
          item-value="uuid"
          :placeholder="`Select ${article(mode)} ${mode}`" 
          hide-details
        >
          <template v-slot:item="{ item }">
            <!-- <v-icon class="mr-4">
              {{ typeIcon }}
            </v-icon> -->
            {{ item.name || item.uuid }}
            <v-spacer />
            <v-icon>
              <template v-if="isOwner(item)">
                mdi-account-outline
              </template>
              <template v-else>
                mdi-share-variant-outline
              </template>
            </v-icon>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$router.go(-1)">Cancel</v-btn>
        <v-btn text color="success" @click="$emit('submitted', selected)" :disabled="!selected">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Files from '@/api/files'
import Datasets from '@/api/datasets'
import Predictions from '@/api/predictions'
import Exports from '@/api/exports'
export default {
  name: "dlgOpen",
  props: {
    mode: { type: String, required: true },
  },
  data() {
    return {
      dialog: true,
      selected: null,
      items: null
    }
  },
  async mounted() {
    if (this.mode == 'file') {
      await Files.list().then(response => this.items = response.data.results.filter(e => e.status == 'SUCCESS'))
    } else if (this.mode == 'dataset') {
      await Datasets.list().then(response => this.items = response.data.results.filter(e => e.status == 'SUCCESS'))
    } else if (this.mode == 'export') {
      await Exports.list().then(response => this.items = response.data.results.filter(e => e.status == 'SUCCESS' && e.config['targets'].includes('oil') && e.config['targets'].includes('gas')))
    } else if (this.mode == 'prediction') {
      await Predictions.list().then(response => this.items = response.data.results.filter(e => e.status == 'SUCCESS'))
    }
  },
  computed: {
    typeIcon() {
      if (this.mode == "file") return "mdi-file-document"
      if (this.mode == "dataset") return "mdi-database"
      if (this.mode == "prediction") return "mdi-finance"
      if (this.mode == "export") return "mdi-file-table"
      if (this.mode == "holdback") return "mdi-chart-gantt"
    }
  },
  methods: {
    article(word) {
      const lowerCaseWord = String(word).toLowerCase()
      const firstLetter = lowerCaseWord[0]

      // Common exceptions where pronunciation differs from spelling
      const anExceptions = ['hour', 'honest', 'honor', 'heir'] // words starting with a silent 'h'
      const aExceptions = ['user', 'unicorn', 'university', 'european'] // words starting with 'u' or 'eu' that sound like 'yoo'

      if (anExceptions.includes(lowerCaseWord)) {
        return 'an'
      } else if (aExceptions.includes(lowerCaseWord)) {
        return 'a'
      } else if ('aeiou'.includes(firstLetter)) {
        return 'an'
      } else {
        return 'a'
      }
    }
  }
}
</script>